import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ReadMoreComponentDef } from '@df/ui/display/read-more.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
@Component({
    selector: 'read-more',
    templateUrl: './read-more.html',
    styleUrls: ['./read-more.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ICmsClientModule, CommonModule, TranslationModule]
})
export class ReadMoreComponent extends ReadMoreComponentDef {
    /**
     * Read more text
     */
    @Input()
    readMore?: string;

    @Input()
    readLess?: string;

    @Input()
    mobileReadMoreColor?: string;

    /**
     * Icon
     */
    @Input()
    showIcon?: boolean = true;

    /**
     * Modal
     */
    @Input()
    readMoreModalButton?: string;

    @Input()
    readMoreModalId?: string;

    @Input()
    readMoreModalData?: any;

    @Output()
    visibleUpdate = new EventEmitter<boolean>();
    override toggle(to = !this.isMoreVisible): void {
        this.timeoutService.setTimeout(() => {
            this.isMoreVisible = to;
            this.visibleUpdate.next(to);
            this.changeDetectorRef.detectChanges();
        }, 50);
    }
    override ngOnChanges(changesObj: SimpleChanges) {
        super.ngOnChanges(changesObj);
        if (changesObj['text']) {
            this.visibleUpdate.next(false);
        }
    }
}
